<template>
    <div class="cont-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('cbsx.xzzq')}}</div>
        </div>       
        <ul class="select-box"> 
            <li class="select" :class="{active: curIdx == index}" v-for="(item,index) in dayArr" @click="change(index,item)" :key="index">
                <div class="t1">{{item}}{{$t('cbsx.days')}}</div>                
                <div class="arrow"></div>
            </li>            
        </ul>
    </div>
</template>
<script>
export default {
    name: 'selectCbBz',
    data () {
        return {
            uid: '',
            token: '',
            curIdx: 0,
            dayArr: [90,180,365]                                     
        }
    },
    created(){ 
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token'); 
    },
    mounted(){
        if(!localStorage.getItem('day')){
            localStorage.setItem('dayIndex',0); 
            localStorage.setItem('day','90'); 
        }else{
            this.curIdx = localStorage.getItem('dayIndex')
        }
    },
    methods: {        
        change(idx,day){           
            this.curIdx = idx;           
            localStorage.setItem('dayIndex',idx);
            localStorage.setItem('day',day);
            this.$router.go(-1);         
        },
        goBack(){
            this.$router.go(-1);
        },       
    }
}
</script>
<style scoped>
    .cont-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        /* background: #040925; */
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: .8rem;
        font-size: .36rem;
        line-height: .8rem;
        text-align: center;
    }   
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .24rem;
        height: .44rem;
        transform: translateY(-50%);        
    }   
    .select-box{        
        padding: 1rem .3rem 0;     
        /* background: #0E1530;   */
        background: rgb(14, 21 ,48,.5);
    }
    .select-box .select{
        display: flex;   
        align-items: center;     
        margin-top: .3rem;
        padding-bottom: .2rem;
        color: #fff;
        font-size: .3rem;
        border-bottom: 1px solid #858585;
    }
    .select-box .select:last-child{
        border-bottom: none;
    }
    .select-box .select .icon{
        width: .58rem;
        height: .58rem;
        margin-right: .48rem;
    }
    .select-box .select .t1{
        flex: 1;
        color: #fff;
        font-size: .32rem;
    }
    .select-box .select .t2{
        flex: 1;
        padding-right: .4rem;
        color: #fff;
        font-size: .24rem;
        text-align: right;
    }
    .select-box .select.active .arrow{
        width: .3rem;
        height: .15rem;
        border-left: 2px solid #4bb3e8;
        border-bottom: 2px solid #4bb3e8;
        transform: rotate(-45deg);
    }
</style>


// WEBPACK FOOTER //
// src/pages/selectDay.vue